import { render, staticRenderFns } from "./ad-log-new-modal.vue?vue&type=template&id=0223afa6&scoped=true&"
import script from "./ad-log-new-modal.vue?vue&type=script&lang=js&"
export * from "./ad-log-new-modal.vue?vue&type=script&lang=js&"
import style0 from "./ad-log-new-modal.vue?vue&type=style&index=0&id=0223afa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223afa6",
  null
  
)

export default component.exports